var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1764214352940,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 11745,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M919.04 344.064L757.76 139.4688A69.8368 69.8368 0 0 0 702.7712 112.64h-370.688a70.0928 70.0928 0 0 0-53.9136 25.1904L107.52 342.0672a92.7744 92.7744 0 0 0 2.4064 121.344l342.3232 377.4976a92.16 92.16 0 0 0 68.4544 30.3616h1.1264a92.6208 92.6208 0 0 0 68.8128-32.0512L916.48 461.568a92.5696 92.5696 0 0 0 2.56-117.504z",
    fill: "#0A84FF",
    "p-id": 11746,
    "data-spm-anchor-id": "a313x.search_index.0.i14.2da33a81hblUCU",
    className: "selected"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M513.3824 635.3408a69.7344 69.7344 0 0 1-54.9376-26.5216l-152.3712-191.488a31.2832 31.2832 0 1 1 48.9472-38.9632l152.4224 191.488a7.424 7.424 0 0 0 5.9904 2.8672 7.3216 7.3216 0 0 0 5.9904-3.0208L663.3472 378.88a31.3344 31.3344 0 1 1 49.9712 37.7344l-143.8208 190.6688a69.8368 69.8368 0 0 1-55.1424 27.9552z",
    fill: "#FFFFFF",
    "p-id": 11747
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.59cf32cb57ddf292bfbbb8e3cf3f04d2.svg";
export { ForwardRef as ReactComponent };